module.exports = __webpack_public_path__ + "web/img/userhead.126beac0.png";